import { createI18n, type I18n, type Composer, type I18nOptions } from 'vue-i18n'
import { getInitialLocale, lang } from './detect'
import { loadLocaleData, setI18nLanguage, PRELOADED_LOCALES } from './loader'
import { type LocaleCode, getUILangOptions } from './langs'
// import { datetimeFormats, numberFormats } from './formats' // 如需

let _switching = false

// 仅应用语言（不改本地存储），用于初始化或外部同步
export async function applyLanguage(code: LocaleCode) {
  if (_switching) return
  _switching = true
  try {
    await loadLocaleData(i18n, code)
  } finally {
    _switching = false
  }
}

// 切换语言（落盘并应用），相同值避免重复工作
export const changeLanguage = async (code: LocaleCode) => {
  if (lang.value !== code) {
    lang.value = code
  }

  await applyLanguage(code)
}

export type MyI18nOptions = I18nOptions & {}
export function setupI18n(options: MyI18nOptions = {}): I18n {
  const i18n = createI18n({
    ...options,
    // datetimeFormats,
    // numberFormats,
  })
  const userPreferredLang = (options.locale as string) || getInitialLocale()
  lang.value = userPreferredLang as LocaleCode
  const preloadMsgs = PRELOADED_LOCALES[userPreferredLang]
  if (preloadMsgs) {
    // 初始语言已预载：同步注入，首屏不闪烁
    setI18nLanguage(i18n, userPreferredLang, preloadMsgs)
  } else {
    // 未预载：先设置locale，不设置messages，再微任务异步切回初始语言
    setI18nLanguage(i18n, userPreferredLang)
    queueMicrotask(() => changeLanguage(userPreferredLang as LocaleCode))
  }

  return i18n
}

const i18n = setupI18n({
  legacy: false,
  fallbackLocale: 'en',
  messages: {},
  globalInjection: false,
})

export function i18nRender(key: string, values?: Record<string, any>): string {
  return (i18n.global as Composer).t(key, values)
}

export { getUILangOptions, lang }
export type { LocaleCode }
export default i18n
